import { get, post } from '../actions/method';

export const unlockSchedule = async (code) => {
  let params = {
    body: { code },
  };
  return await post('app/schedule/validate', params);
};
export const getSchedule = async () => {
  return await get('app/schedule');
};

export const postSchedule = async (data) => {
  let params = {
    body: data,
  };
  return await post('app/schedule', params);
};
